import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { MessageSquare, Store, Users, ShoppingBag, User, LayoutDashboard } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const navItems = [
    { path: '/shops', icon: Store, label: 'Shops' },
    { path: '/chats', icon: MessageSquare, label: 'Chats' },
    ...(user?.isShopOwner ? [{ path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' }] : []),
    { path: '/communities', icon: Users, label: 'Groups' },
    { path: '/orders', icon: ShoppingBag, label: 'Orders' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  const isActive = (path) => location.pathname.startsWith(path);

  // Hide bottom nav on chat windows and other detail pages
  const hideNav = location.pathname.match(/\/(chats|communities|shops|orders|dashboard)\/[^/]+/);

  return (
    <div className="app-container">
      <div className="content-area">
        <Outlet />
      </div>

      {!hideNav && (
        <nav className="bottom-nav">
          {navItems.map(({ path, icon: Icon, label }) => (
            <button
              key={path}
              className={`nav-item ${isActive(path) ? 'active' : ''}`}
              onClick={() => navigate(path)}
              id={`nav-${label.toLowerCase()}`}
            >
              <Icon className="nav-icon" size={22} strokeWidth={isActive(path) ? 2.5 : 1.8} />
              <span>{label}</span>
            </button>
          ))}
        </nav>
      )}
    </div>
  );
}
